export const ADD_STATE = 'ADD_STATE';
export const REMOVE_STATE = 'REMOVE_STATE';
export const UPDATE_STATE = 'UPDATE_STATE';
export const REMOVE_TRANSITION = 'REMOVE_TRANSITION';
